import React, { useEffect, useState } from 'react';
import Select from 'react-select';

const customStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
};

const SelectFild = ({ Firstop, selectName, options, value, onChange, onBlur }) => {
    const [optionsList, setOptionsList] = useState([]);

    useEffect(() => {
        if (options && Array.isArray(options)) {
            const updatedOptions = options.map(item => ({
                value: item.id,
                label: item.name,
            }));
            setOptionsList(updatedOptions);
        }
    }, [options]);

    return (
        <Select
            name={selectName}
            value={optionsList.find(option => option.value == value) || null}
            onChange={onChange}
            onBlur={onBlur}
            options={optionsList}
            placeholder={'Select'}
            isClearable
            isSearchable
            menuPortalTarget={document.body}
            styles={customStyles}
        />
    );
};


export default SelectFild;